import { render, staticRenderFns } from "./LongTimePeriod.vue?vue&type=template&id=e227a626&scoped=true"
import script from "./LongTimePeriod.vue?vue&type=script&lang=ts"
export * from "./LongTimePeriod.vue?vue&type=script&lang=ts"
import style0 from "./LongTimePeriod.vue?vue&type=style&index=0&id=e227a626&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e227a626",
  null
  
)

export default component.exports